import { Autocomplete, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

ResidentDropdown.propTypes = {
  isGroupTrip: PropTypes.bool,
  residents: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.object]),
  onChange: PropTypes.func.isRequired,
  inputValue: PropTypes.string,
  onInputChange: PropTypes.func,
  filterOptions: PropTypes.func,
  residentsList: PropTypes.arrayOf(PropTypes.object),
  facilityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default function ResidentDropdown({
  isGroupTrip = false,
  residents,
  onChange,
  inputValue,
  onInputChange,
  filterOptions,
  residentsList,
  facilityId,
  isLoading,
  disabled = false,
}) {
  return (
    <Autocomplete
      fullWidth
      size="small"
      sx={{ mt: 2 }}
      multiple={isGroupTrip}
      value={residents}
      onChange={onChange}
      inputValue={inputValue}
      onInputChange={onInputChange}
      filterOptions={filterOptions}
      id="resident-search-dialog"
      options={isLoading ? [] : residentsList}
      getOptionLabel={(option) => option?.label || ''}
      renderInput={(params) => (
        <TextField
          {...params}
          label={isGroupTrip ? 'Residents' : 'Resident'}
          placeholder="Please type to search or add a resident"
          autoComplete="off"
          disabled={disabled || !facilityId}
        />
      )}
      disabled={disabled || !facilityId}
      loading={isLoading}
    />
  );
}
